<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expense Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Expense Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expense Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
         {
          key: "category",
          sortable: true,
          label: "Item Category",
        },
          {
              key: "item.item_name",
              sortable: true,
              label: "Item Name",
          },
        {
          key: "amount_field",
          sortable: true,
          label: "AMOUNT",
        },
           {
          key: "expense_date",
          sortable: true,
          label: "EXPENSE DATE",
        },
        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "payee_field",
          sortable: true,
          label: "RECEIVER",
        },
        {
          key: "addedBy",
          sortable: true,
          label: "MADE BY",
        }
      ],
      data: {
        dto: moment(new Date()).format("YYYY-MM-DD"),
        dfrom: "",
        category: "",
        item:""
      },
      totals: {
        totalAmount: 0,
        totalBalance: 0,
      },
      filterTitle: "",
      export_title: "",
      filteredReport: [],
      //========== EXPORT ==============================
      json_fields: {
        ITEM: "item.item_name",
        AMOUNT: "amount",
        BALANCE: "balance",
        RECEIVER: "export_payeename",
        MADE_BY: "addedBy.name",
        BRANCH: "branch.name",
        DATE_TIME: "dateCreated",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters("expense", ["Expenses","ExpenseItems", "ExpenseCategories"]),
    ...mapState("expense", ["expenses"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  watch: {
    expenses(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Expenses ? this.Expenses.length : 1;
  },
  methods: {
    ...mapActions({
      FetchExpenses: "expense/fetchExpenses",
      FetchExpenseCategories: "expense/fetchExpenseCategories",
      FetchExpenseItems: "expense/fetchExpenseItems",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assiginData() {
      this.filteredReport = this.Expenses;

      let total = 0;
      let bala = 0;
      this.Expenses.forEach((value) => {
        let amt = parseInt(value.amount);
        total = total + amt;

        let balaamt = parseInt(value.balance);
        bala = bala + balaamt;
      });
      this.totals.totalAmount = total;
      this.totals.totalBalance = bala;
    },

    filterReport() {
      this.totals.totalAmount = 0;
      this.totals.totalBalance = 0;
      let date2 = this.data.dto;
      let date1 = this.data.dfrom;
      let total = 0;
      let bala = 0;
      this.filteredReport = this.Expenses.filter((element) => {
        if (this.data.item != "" && this.data.dfrom == "" && this.data.dto != "") {
          if (element.item_id == this.data.item && element.date <= date2) {
            let amt = parseInt(element.amount);
            total = total + amt;

            let balaamt = parseInt(element.balance);
            bala = bala + balaamt;
            this.totals.totalAmount = total;
            this.totals.totalBalance = bala;
          }
          this.ExpenseItems.filter((element) => {
            if (element.id == this.data.item) {
              let expcat = element.itemName;
              this.filterTitle =
                "Expense Report For " + expcat + " Up To " + this.data.dto;
            }
          });

          return element.item_id == this.data.item && element.date <= date2;
        } else if (
          this.data.item == "" &&
          this.data.dfrom != "" &&
          this.data.dto != ""
        ) {
          this.export_title =
            "expense_report_for_" + this.data.dfrom + "-" + this.data.dto;
          this.filterTitle =
            "Expense Report From " + this.data.dfrom + " To " + this.data.dto;
          if (element.date >= date1 && element.date <= date2) {
            let amt = parseInt(element.amount);
            total = total + amt;

            let balaamt = parseInt(element.balance);
            bala = bala + balaamt;
            this.totals.totalAmount = total;
            this.totals.totalBalance = bala;
          }

          return element.date >= date1 && element.date <= date2;
        } else if (
          this.data.item != "" &&
          this.data.dfrom != "" &&
          this.data.dto != ""
        ) {
          if (
            element.item_id == this.data.item &&
            element.date >= date1 &&
            element.date <= date2
          ) {
            let amt = parseInt(element.amount);
            total = total + amt;

            let balaamt = parseInt(element.balance);
            bala = bala + balaamt;
            this.totals.totalAmount = total;
            this.totals.totalBalance = bala;
          }

          this.ExpenseItems.filter((element) => {
            if (element.id == this.data.item) {
              let expcatx = element.itemName;
              this.filterTitle =
                "Expense Report For " +
                expcatx +
                " From " +
                this.data.dfrom +
                " To " +
                this.data.dto;
            }
          });

          return (
            element.item_id == this.data.item &&
            element.date >= date1 &&
            element.date <= date2
          );
        }
      });
    },
  },
  created() {
    this.FetchExpenses();
    this.FetchExpenseCategories();
    this.assiginData();
    this.FetchExpenseItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
           
              <div class="col-4">
                <div class="form-group">
                  <label>Expense Item</label>
                  <model-list-select :list="ExpenseItems ? ExpenseItems : []" 
                  v-model="data.item" option-value="id"
                    option-text="itemName" class="mb-3" placeholder="Select Item" @input="filterReport()">
                  </model-list-select>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dfrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dto"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'EXPENSE REPORT FOR' + currentdate"
                  type="csv"
                  :name="'expense_report_' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                foot-clone
                :items="filteredReport ? filteredReport : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(balance_field)="data">
                  {{ thousandSeprator(data.item.balance) }}
                </template>
                <template #cell(amount_field)="data">
                  {{ thousandSeprator(data.item.amount) }}
                </template>
                <template #cell(branch)="data">
                  {{ data.item.branch.name }}
                </template>
                <template #cell(addedBy)="data">
                  {{ data.item.addedBy.name }}
                </template>
                <template #cell(category)="data">
                  {{ data.item.category.category_name }}
                </template>
                <template #cell(payee_field)="data">
                  {{
                    data.item.payeeType == 1
                      ? data.item.payee.staff_name
                      : data.item.payee
                  }}
                </template>
                <template #foot(index)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(amount_field)="">
                  {{ thousandSeprator(totals.totalAmount) }}
                </template>
                <template #foot(balance_field)="">
                  {{ thousandSeprator(totals.totalBalance) }}
                </template>
                <template #foot(payee_field)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(addedBy)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(dateCreated)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(branch)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(item_name)="">
                  <span class="text-danger"></span>
                </template>
              </b-table>
              <center>
                <h3 v-if="!Expenses" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
